import GtmProduct from '~/models/Product/GtmProduct'
import { useBasketStore } from '~/stores/basket'
import FullProduct from '~/models/Product/FullProduct'

export const transformFullProductToGtmProduct = (product: FullProduct): GtmProduct => {
    const basketStore = useBasketStore()

    let price = product.priceNoVat
    const rrp = product.originalPriceNoVat
    let discount: number | null = null
    if (rrp && rrp > price) {
        discount = +(rrp - price).toFixed(2)
        price = rrp
    }

    return {
        isAvailable: product.status === 1,
        id: product.id,
        name: product.name,
        brand: product.brandName,
        producer: product.manufacturerName,
        rating: product.rate,
        availability: product.amountInStock,
        availabilityPeriod: product.availabilityPeriod,
        price,
        discount,
        categories: product.categoryNames,
        quantity: basketStore.productAmounts[product.id] || 0,
        vat: product.vat,
    }
}
